import { Route } from 'react-router-dom';
import MiddleLayout from '../layout/PublicLayout/MiddleLayout';
import {
  AcademicCalendarPage,
  CustomDynamicPage,
  DepartmentsPage,
  ExternalPartnerRegistration,
  ExternalUsersRegistrationPage,
  FIJJobsDetailPage,
  FIJPublicListPage,
  FjJobsPage as FriJobsPublicPage,
  ForgottenPasswordPage,
  FriEduDetailPage,
  FriEduPage,
  FriJobsPublicDetailPage,
  FriOpenDatesDetailPage,
  FriOpenEventsDetailPage,
  FriOpenEventsPage,
  FriOpenWorkshopsDetailPage,
  HomePage,
  IngProjectsPublicDetailPage,
  IngProjectsPublicPage,
  MeteoStationPage,
  NewsArchivePage,
  NewsDetailPage,
  PollsVotePage,
  ReservationsApprovalPage,
  ReservationsOverviewPublic,
  SearchPage,
  StudyPlansPage,
  DissertationsPage,
  DissertationsDetailPage,
  } from '../pages/PublicPages/index.jsx';
import { routes } from '../../utils/helpers/ApiClient';
import ContactPage from '../pages/PublicPages/ContactPage/ContactPage';
import IpChangeRequestApprovalPage from '../pages/PublicPages/IngProjects/IpChangeRequestApprovalPage.jsx';
import React from 'react';
import CongratulationsPage from '../pages/PublicPages/CongratulationsPage/CongratulationsPage.jsx';
import QuestionToApplicationPage from '../pages/PublicPages/QuestionToApplicationPage/QuestionToApplicationPage.jsx';

const PublicRoutes = () => (
  <>
    <Route
      index
      element={
        <MiddleLayout>
          <HomePage />
        </MiddleLayout>
      }
    />
    <Route
      path={routes.search}
      element={
        <MiddleLayout hideRightSidebar>
          <SearchPage />
        </MiddleLayout>
      }
    />
    <Route
      path="/login"
      element={
        <MiddleLayout>
          <HomePage />
        </MiddleLayout>
      }
    />
    <Route
      path="/logout"
      element={
        <MiddleLayout>
          <HomePage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.newsDetail}/:slug`}
      element={
        <MiddleLayout>
          <NewsDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.newsDetail2}/:slug`}
      element={
        <MiddleLayout>
          <NewsDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.newsDetailEnglish}/:slug`}
      element={
        <MiddleLayout>
          <NewsDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.externalPartnerRegistration}`}
      element={
        <MiddleLayout hideRightSidebar>
          <ExternalPartnerRegistration />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.externRegister}/:courseId`}
      element={
        <MiddleLayout hideRightSidebar>
          <ExternalUsersRegistrationPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.externalUserRegistration}`}
      element={
        <MiddleLayout hideRightSidebar>
          <ExternalUsersRegistrationPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.article}/:slug`}
      element={
        <MiddleLayout>
          <CustomDynamicPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.articleEnglish}/:slug`}
      element={
        <MiddleLayout>
          <CustomDynamicPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.department}/:slug`}
      element={
        <MiddleLayout>
          <DepartmentsPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.departmentEnglish}/:slug`}
      element={
        <MiddleLayout>
          <DepartmentsPage />
        </MiddleLayout>
      }
    />
    <Route
      path={'/akademicky-kalendar'}
      element={
        <MiddleLayout hideRightSidebar>
          <AcademicCalendarPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`/kontakt`}
      element={
        <MiddleLayout>
          <ContactPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`/contact`}
      element={
        <MiddleLayout>
          <ContactPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`/blahozelanie`}
      element={
        <MiddleLayout>
          <CongratulationsPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`/otazka-k-prihlaske`}
      element={
        <MiddleLayout>
          <QuestionToApplicationPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`/application-question`}
      element={
        <MiddleLayout>
          <QuestionToApplicationPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`/congratulations`}
      element={
        <MiddleLayout>
          <CongratulationsPage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.dissertationsDetail}
      element={
        <MiddleLayout hideRightSidebar>
          <DissertationsPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.dissertationsDetail}/:id`}
      element={
        <MiddleLayout hideRightSidebar>
          <DissertationsDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.newsArchive}`}
      element={
        <MiddleLayout hideRightSidebar>
          <NewsArchivePage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.reservationsOverview}
      element={
        <MiddleLayout hideRightSidebar>
          <ReservationsOverviewPublic />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.reservationsChangeState}
      element={
        <MiddleLayout>
          <ReservationsApprovalPage />
        </MiddleLayout>
      }
    />

    <Route
      path="/schvalovanie-zmeny-projektu"
      element={
        <MiddleLayout>
          <IpChangeRequestApprovalPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`${routes.studyPlans}/:shortcut?/:year?`}
      element={
        <MiddleLayout hideRightSidebar>
          <StudyPlansPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`${routes.fijJobs}`}
      element={
        <MiddleLayout hideRightSidebar>
          <FIJPublicListPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.fijJobDetail}/:id`}
      element={
        <MiddleLayout hideRightSidebar>
          <FIJJobsDetailPage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.eduCourses}
      element={
        <MiddleLayout hideRightSidebar>
          <FriEduPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.eduCourses}/:id`}
      element={
        <MiddleLayout hideRightSidebar>
          <FriEduDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={`${routes.friJobsList}`}
      element={
        <MiddleLayout hideRightSidebar>
          <FriJobsPublicPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`${routes.friJobsDetail}/:id`}
      element={
        <MiddleLayout hideRightSidebar>
          <FriJobsPublicDetailPage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.ingProjectsPublicList}
      element={
        <MiddleLayout hideRightSidebar>
          <IngProjectsPublicPage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.ingProjectsPublicDetail(':projectId')}
      element={
        <MiddleLayout hideRightSidebar>
          <IngProjectsPublicDetailPage />
        </MiddleLayout>
      }
    />

    <Route
      path={`${routes.polls}/:slug`}
      element={
        <MiddleLayout>
          <PollsVotePage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.meteoStation}
      element={
        <MiddleLayout hideRightSidebar>
          <MeteoStationPage />
        </MiddleLayout>
      }
    />

    {/*FRI.open PUBLIC*/}
    <Route
      path={routes.friOpenEventsList}
      element={
        <MiddleLayout hideRightSidebar>
          <FriOpenEventsPage />
        </MiddleLayout>
      }
    />
    <Route
      path={routes.friOpenEventsDetail(':eventId')}
      element={
        <MiddleLayout hideRightSidebar>
          <FriOpenEventsDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={routes.friOpenWorkshopsDetail(':workshopId')}
      element={
        <MiddleLayout hideRightSidebar>
          <FriOpenWorkshopsDetailPage />
        </MiddleLayout>
      }
    />
    <Route
      path={routes.friOpenDatesDetail(':dateId')}
      element={
        <MiddleLayout hideRightSidebar>
          <FriOpenDatesDetailPage />
        </MiddleLayout>
      }
    />

    <Route
      path={routes.forgottenPassword}
      element={
        <MiddleLayout>
          <ForgottenPasswordPage mode={'email'} />
        </MiddleLayout>
      }
    />
    <Route
      path={routes.passwordReset(':token')}
      element={
        <MiddleLayout>
          <ForgottenPasswordPage mode={'password'} />
        </MiddleLayout>
      }
    />

  </>
);

export default PublicRoutes;
